import React from 'react';
import { Box, Tooltip, useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useServiceHealthQuery } from 'src/features/service-health/api/list-service-health';
import hasPerm from 'src/utils/hasPerm';
import { VIEW_SERVICE_HEALTH } from 'src/constants/permissions';

const ServiceHealthIndicator = () => {
  const theme = useTheme();
  const history = useHistory();
  const account = useSelector((state) => state.account);
  const perms = account.perms?.perms || [];
  const canViewServiceHealth =
    account.user?.is_superuser || hasPerm(VIEW_SERVICE_HEALTH, perms);

  const { data } = useServiceHealthQuery({ queryConfig: { enabled: canViewServiceHealth } });

  const statuses = data?.map((item) => item.status) || [];
  let status = null;
  if (statuses.length) {
    if (statuses.includes('RED')) status = 'RED';
    else if (statuses.includes('AMBER')) status = 'AMBER';
    else if (statuses.every((s) => s === 'GREEN')) status = 'GREEN';
  }

  const colors = {
    GREEN: theme.palette.success.main,
    AMBER: theme.palette.warning.main,
    RED: theme.palette.error.main,
  };

  const color = colors[status] || theme.palette.text.secondary;

  return (
    <Tooltip title="Service health">
      <Box
        role="img"
        aria-label="Service health"
        width={20}
        height={20}
        borderRadius="50%"
        bgcolor={color}
        mr={1.5}
        onClick={() => canViewServiceHealth && history.push('/app/service-health')}
        style={{ cursor: canViewServiceHealth ? 'pointer' : 'default' }}
      />
    </Tooltip>
  );
};

export default ServiceHealthIndicator;
